import { NgModule, Provider } from '@angular/core';
import { DialogActionComponent } from './components/dialog-action/dialog-action.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogDirective } from './directives/dialog.directive';
import {
  CONFIRM_ACTIONS,
  DANGER_CONFIRM_ACTIONS,
  DEFAULT_ACTIONS,
  DEFAULT_DIALOG_CONFIG,
  DIALOG_CONFIG,
  confirmDialogActionFactory,
  dangerConfirmDialogActionFactory,
  defaultDialogActionFactory,
} from './provider';
import { BaseDialogService } from './services/base-dialog.service';
import { ConfirmDialogService } from './services/confirm-dialog.service';
import { DialogService } from './services/dialog.service';

@NgModule({
  imports: [DialogComponent, DialogDirective, DialogActionComponent],
  providers: [provideDialogDefaultConfig()],
})
export class DialogModule {}

/**
 * Provides dialog default config
 */
export function provideDialogDefaultConfig(): Provider[] {
  return [
    BaseDialogService,
    DialogService,
    ConfirmDialogService,
    { provide: DIALOG_CONFIG, useValue: DEFAULT_DIALOG_CONFIG },
    {
      provide: DEFAULT_ACTIONS,
      useFactory: defaultDialogActionFactory,
      deps: [BaseDialogService, DIALOG_CONFIG],
    },
    {
      provide: CONFIRM_ACTIONS,
      useFactory: confirmDialogActionFactory,
      deps: [BaseDialogService, DIALOG_CONFIG],
    },
    {
      provide: DANGER_CONFIRM_ACTIONS,
      useFactory: dangerConfirmDialogActionFactory,
      deps: [BaseDialogService, DIALOG_CONFIG],
    },
  ];
}
